<template>
  <div class="building-tree">
    <el-tree
      :data="data"
      node-key="id"
      default-expand-all
      :expand-on-click-node="false"
    >
      <div
        class="custom-tree-node"
        slot-scope="{ node, data }"
        :class="checking && validateInput(node, data) ? 'error-input' : ''"
      >
        <span class="mr-5">{{
          data.type === 'building'
            ? $t('text.facility')
            : data.type === 'floor'
            ? $t('text.floor')
            : $t('text.room')
        }}</span>
        <el-input
          v-model="data.label"
          size="mini"
          :placeholder="
            data.type === 'building'
              ? $t('text.facility_name')
              : data.type === 'floor'
              ? $t('text.floor_name')
              : $t('text.room_number')
          "
        ></el-input>
        <span v-if="checking && validateInput(node, data)" class="error-text">{{
          validateInput(node, data)
        }}</span>
      </div>
    </el-tree>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import $ from 'jquery'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      checking: false
    }
  },
  props: {
    allBuildings: {
      type: Array,
      require: true
    },
    data: {
      type: Array,
      require: true
    }
  },
  methods: {
    validateInput(node, item) {
      let errMsg = null
      if (item.type === 'building') {
        if (item.label) {
          let allBuildingName = this.allBuildings
            .filter(data => {
              return data.BuildingId !== item.id
            })
            .map(data => {
              return data.BuildingName
            })
          errMsg =
            allBuildingName.indexOf(item.label) !== -1
              ? this.$t('text.facility_name_already_exists')
              : ''
        } else {
          errMsg = this.$t('text.please_enter_facility_name')
        }
      } else if (item.type === 'floor') {
        if (item.label) {
          let allFloorName = this.data[0].children
            .filter(child => child.id !== item.id)
            .map(child => child.label)
          errMsg =
            allFloorName.indexOf(item.label) !== -1
              ? this.$t('text.floor_name_should_be_unique')
              : ''
        } else {
          errMsg = this.$t('text.please_enter_floor_name')
        }
      } else {
        if (item.label) {
          let allRoomName = node.parent.data.children
            .filter(child => child.id !== item.id)
            .map(child => child.label)
          errMsg =
            allRoomName.indexOf(item.label) !== -1
              ? this.$t('text.room_number_should_be_unique')
              : ''
        } else {
          errMsg = this.$t('text.please_enter_room_number')
        }
      }
      return errMsg
    },
    getParams() {
      let params
      if (this.data[0].id) {
        params = [
          {
            OrganisationId: this.$store.getters[`user/selecteOrganisationId`],
            BuildingName: this.data[0].label,
            BuildingId: this.data[0].id,
            Floors: this.data[0].children.map(floor => {
              let rooms = []
              floor.children.forEach(room => {
                let roomObj = {
                  RoomNumber: room.label,
                  RoomId: room.id
                }
                if (room.id < 1) delete roomObj.RoomId
                rooms.push(roomObj)
              })
              let floorObj = {
                FloorName: floor.label,
                FloorId: floor.id,
                Rooms: rooms
              }
              if (floor.id < 1) delete floorObj.FloorId
              return floorObj
            })
          }
        ]
      } else {
        params = [
          {
            OrganisationId: this.$store.getters[`user/selecteOrganisationId`],
            BuildingName: this.data[0].label,
            Floors: this.data[0].children.map(floor => {
              return {
                FloorName: floor.label,
                Rooms: floor.children.map(room => {
                  return {
                    RoomNumber: room.label
                  }
                })
              }
            })
          }
        ]
      }
      return params
    },
    submit() {
      this.checking = true
      this.$nextTick(() => {
        if ($('.error-text').length) return false
        this.save()
      })
    },
    save() {
      this.$emit('loadingChange', true)
      ApiService.SaveBuilding(this.getParams())
        .then(response => {
          this.checking = false
          this.$emit('loadingChange', false)
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.data[0].id
                ? this.$t('text.saved_successfully')
                : this.$t('text.added_successfully')
            })
            this.$emit('saveSuccessfully')
          } else {
            swal({
              icon: 'warning',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.$emit('loadingChange', false)
          this.checking = false
        })
    }
  }
}
</script>
